export abstract class PageInfoTemplateComponent {
    errorCode: string;
    message: string;
}
